import React from 'react';
import { observer } from 'mobx-react';
import { Table } from 'antd';
import { ShowDataProgress } from '../../SmallComponents/ShowDataProgress';
import { PackageCountDown } from './';
import { IPackageSoldInfo, IPackagesTable } from '../../../interfaces';
import { usePackagesSold } from '../../../hooks';
import { tF } from '../../../translate';
import { Catcher, LinkComponent, LoadingApiByIds, ShowDataBytes } from '../../../Components';
import ViewStyles from '../../styles/m_viewStyles.less';

export const TableForSoldPackages: React.FC<IPackagesTable> = observer(({}: IPackagesTable) => {
    const data = usePackagesSold();
    const tableColumns = [
        {
            title: tF('Package Owner'),
            dataIndex: 'companyLink',
        },
        {
            title: tF('Package name'),
            dataIndex: 'packageLink',
        },
        {
            title: tF('Data left'),
            dataIndex: 'showSoldVolume',
            className: ViewStyles.columnRight,
        },
        {
            title: tF('Package Size'),
            dataIndex: 'showPackageVolume',
            className: ViewStyles.columnRight,
        },
        {
            title: tF('Expires in'),
            dataIndex: 'isExpiredName',
        },
        {
            title: tF('Zone'),
            dataIndex: 'zoneLink',
        },
        {
            title: tF('Assigned Cardset'),
            dataIndex: 'cardSetLink',
        },
        {
            title: tF('Credit Remains'),
            dataIndex: 'creditRemainsName',
        },
        {
            title: tF('Auto renewal'),
            dataIndex: 'renewalName',
        },
    ];

    const tableData = data?.map(({ isExpired, expiresDate, createdAt, renewal, ...p }: IPackageSoldInfo) => {
        return {
            key: p.id,
            ...p,
            showSoldVolume: (
                <div className={ViewStyles.columnContentCol100}>
                    <ShowDataBytes bytes={p.soldVolumeByte} isHumanView noDataText={'No data'} />
                    <ShowDataProgress limit={p.dataVolumeByte} used={p.soldVolumeByte} />
                </div>
            ),
            showPackageVolume: (
                <div className={ViewStyles.columnContentCol100}>
                    <ShowDataBytes bytes={p.dataVolumeByte} isHumanView noDataText={'Unlimited'} />
                </div>
            ),
            packageLink: <LinkComponent id={p.packageId} name={p.packageName} currentListComponent={'PackagesSell'} />,
            companyLink: <LinkComponent currentListComponent={'CompaniesList'} id={p.companyId} name={p.companyName} />,
            zoneLink: <LinkComponent currentListComponent={'ZonesList'} id={p.zoneId} name={p.zoneName} />,
            cardSetLink: <LinkComponent currentListComponent={'CardSetsList'} id={p.cardSetId} name={p.cardSetName} />,
            isExpiredName: (
                <div className={ViewStyles.columnContentCol100}>
                    <PackageCountDown
                        expiresDate={expiresDate}
                        createdAt={createdAt}
                        isExpired={isExpired}
                        isRenewed={renewal}
                    />
                </div>
            ),
        };
    });

    return (
        <Catcher>
            <div>
                <LoadingApiByIds idSpinners={['GET_PACKAGES_SOLD']} />
                <Table
                    className={'table-theme'}
                    columns={tableColumns}
                    dataSource={tableData}
                    pagination={false}
                    size={'middle'}
                />
            </div>
        </Catcher>
    );
});
